import api from "./api";

export const listarPlanesCatalogo = async () => {
  try {
    const resp = await api.get("/v1/planes/catalogo");
    return resp.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      return [];
    }
    throw error;
  }
};
